module.exports = __webpack_public_path__ + "static/fonts/Robotoitalic.3a40d39.ttf";